import Api from "../config/api";

export const findTitulosByAgendamentoId = async (variables) => {
  const response = await Api.post("", {
    query: `
      query($agendamentoId: Long) {
        findTitulosByAgendamentoId(agendamentoId: $agendamentoId) {
          parcelas {
            valor
            id
            dataVencimento
            dataPagamento
            status
            excluido
          }
          linkPagamentoAsaas
          ativo
        }
      }
    `,
    variables: variables,
  });

  if (response.data.errors) {
    throw Error("Falha ao conectar o totem");
  }

  return response.data.data.findTitulosByAgendamentoId;
};
